import { useLocation } from 'react-router-dom';
import { getModuleSelected } from './navigationPath';

function useModuleSelected() {
  const { pathname } = useLocation();
  return getModuleSelected(pathname);
}

export default useModuleSelected;
